export const SHOW_HEADBAND = 'SHOW_HEADBAND';
export const HIDE_HEADBAND = 'HIDE_HEADBAND';
